const hr = () => <hr className="my-0 mx-2 py-0" />;

export default hr;
